import toast from 'react-hot-toast';
import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { Bank } from '../types/Banks';

export type ResponseType = {
  list: Bank[];
  instruction: {
    title: string;
    img: string;
  };
};

function serialize(data: any) {
  const response: ResponseType = {
    instruction: {
      title: data.content.message,
      img: data.content.image,
    },
    list: [],
  };
  data.operators.forEach((el) =>
    response.list.push({
      id: el.id,
      name: el.name,
      shortName: el.short_name,
      icon: el.icon,
      categoryId: el.category_id,
      billerId: el.biller_id,
      isActive: el.active,
    })
  );
  return response;
}

type ResultTypes = {
  response?: ResponseType;
  error?: any;
};

export const fetchFastagBanks = (): Promise<ResultTypes> =>
  new Promise((resolve) => {
    (async function callBalanceApi() {
      const url = `${apiConfig('catalog')}/api/v2/operatorList/?vendor_id=8`;
      const { response, error }: any = await getMethod({
        endPoint: url,
      });
      if (response) {
        if (response?.data) {
          resolve({ response: serialize(response.data) });
        } else resolve({ error: {} });
      }
      if (error) {
        resolve({ error });
        toast.error('Unable to fetch fastag banks');
      }
    })();
  });
